import { ReactNode, useContext, useEffect, useState } from "react";
import { AxiosError } from "axios";

import { HttpClientContext, X_REQUEST_ID } from "../../../app/client";
import { ConfigItem as Item } from "../../../app/backendTypes";
import Loading from "../Loading";
import Error from "../Error";

function ItemLoader(props: {
  kind: string;
  variant: string;
  render: (value: Item) => ReactNode;
}) {
  const [item, setItem] = useState<Item>({} as Item);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | undefined>(undefined);

  const client = useContext(HttpClientContext);

  useEffect(() => {
    client
      ?.get<Item>(`/api/${props.variant}/${props.kind}`)
      .then((res) => setItem(res.data))
      .catch((e: AxiosError) => setError(e.response?.headers[X_REQUEST_ID]))
      .finally(() => setLoading(false));
  }, [client, props.kind, props.variant]);

  if (loading) return <Loading />;

  if (error) return <Error error={error} />;

  return <>{props.render(item)}</>;
}

export default ItemLoader;
